import { render, staticRenderFns } from "./SupervisorSubmitHistory.vue?vue&type=template&id=5c050244&scoped=true"
import script from "./SupervisorSubmitHistory.vue?vue&type=script&lang=js"
export * from "./SupervisorSubmitHistory.vue?vue&type=script&lang=js"
import style0 from "./SupervisorSubmitHistory.vue?vue&type=style&index=0&id=5c050244&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c050244",
  null
  
)

export default component.exports